import _get from 'lodash/get';

const getContent = (content, section, key) => {
    if (section) {
        if (key) {
            return _get(content, [section, key], {});
        }
        return _get(content, section, {});
    }

    return content || {};
};

export default getContent;
